/**
 * TabStatus — Zakładka "Status" (domyślnie aktywna w trybie Tabsów).
 *
 * Pokazuje syntetyczny widok aktualnego stanu konfiguracji + szybkie akcje
 * (Health Check + przycisk "Usuń konfigurację").
 *
 * Props:
 *   - adminConfig (object)
 *   - storageInfo (object)
 *   - savedNip (string)
 *   - environment (string)
 *   - onRefresh (callback)  — odśwież dane parent po akcji
 */
import { Activity } from "lucide-react";
import { StatusPanel } from "../components/StatusPanel";
import { HealthCheckButton } from "../components/HealthCheckButton";
import { DeleteConfigButton } from "../components/DeleteConfigButton";

export const TabStatus = ({
  adminConfig,
  storageInfo,
  savedNip,
  environment = "PROD",
  onRefresh,
}) => {
  const hasConfig = !!adminConfig?.has_cert || !!savedNip;

  return (
    <div className="space-y-6" data-testid="tab-status">
      <StatusPanel
        adminConfig={adminConfig}
        storageInfo={storageInfo}
        savedNip={savedNip}
        environment={environment}
      />

      <div className="border-t border-gray-100 pt-6">
        <div className="flex items-center gap-2 mb-4">
          <Activity className="w-4 h-4 text-gray-500" />
          <h3 className="text-sm font-semibold text-gray-700">Szybkie akcje</h3>
        </div>
        <HealthCheckButton onChecked={onRefresh} />
      </div>

      <div className="border-t border-gray-100 pt-6">
        <DeleteConfigButton hasConfig={hasConfig} onDeleted={onRefresh} />
      </div>
    </div>
  );
};

export default TabStatus;
